import type {
    AbandonCommerceEnrollmentRequest,
    AbandonCommerceEnrollmentResponse,
} from "@teqtank/commerce-contracts";
import type { CommerceOperation } from "@teqtank/commerce-transport";
export const abandonCommerceEnrollmentOperation: CommerceOperation<
    AbandonCommerceEnrollmentRequest,
    AbandonCommerceEnrollmentResponse
> = Object.freeze({ name: "commerce.enrollment.abandon" });
